/**
 * @description List of supported UI elements.
 */
export enum UIElementType {
  BUTTON = 'UE-BUTTON',
  CHECKBOX = 'UE-CHECKBOX',
  CHECK_BUTTONS = 'UE-CHECK-BUTTONS',
  COLOR = 'UE-COLOR',
  COUNTER = 'UE-COUNTER',
  DATEPICKER = 'UE-DATEPICKER',
  LABEL = 'UE-LABEL',
  MESSAGE = 'UE-MESSAGE',
  RADIO_BUTTONS = 'UE-RADIO-BUTTONS',
  SELECTPICKER = 'UE-SELECT',
  SWITCHER = 'UE-SWITCHER',
  TEXT = 'UE-TEXT',
  TEXTAREA = 'UE-TEXTAREA',
  CHECK_ITEM = 'UE-CHECK-ITEM',
  RADIO_ITEM = 'UE-RADIO-ITEM',
  SELECT_ITEM = 'UE-SELECT-ITEM',
  ICON = 'UE-ICON',
  MERGETAGS = 'UE-MERGETAGS',
  FONT_FAMILY_SELECT = 'UE-FONT-FAMILY-SELECT',
  NESTED_CONTROL = 'UE-NESTED-CONTROL',
  EXPANDABLE = 'UE-EXPANDABLE',
  EXPANDABLE_HEADER = 'UE-EXPANDABLE_HEADER',
  EXPANDABLE_CONTENT = 'UE-EXPANDABLE_CONTENT',
  ORDERABLE = 'UE-ORDERABLE',
  ORDERABLE_ITEM = 'UE-ORDERABLE-ITEM',
  ORDERABLE_ICON = 'UE-ORDERABLE-ICON',
  REPEATABLE = 'UE-REPEATABLE',
  DRAGGABLE_BLOCK = 'UE-DRAGGABLE-BLOCK',
  AMP_FORM_SERVICE_PICKER = 'UE-AMP-FORM-SERVICE-PICKER',
  MULTIPLE_SELECT = 'UE-MULTIPLE_SELECT',
  SCROLLABLE = 'UE-SCROLLABLE-CONTAINER',
}
